var _defs, _circle, _path, _path2, _path3, _g, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path5, _path6, _polygon, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "id-front",
    "data-name": "ID Front",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 285 285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-frnt1{fill:#d1dced;}.cls-frnt2{fill:#eff5ff;}.cls-frnt3{fill:#6576ff;}.cls-frnt4{fill:#fff;}.cls-frnt5{opacity:0.1;}.cls-frnt6{fill:#a3b5d1;}.cls-frnt7{fill:#b4c4db;}.cls-frnt8{fill:#364ed8;}.cls-frnt9{fill:#e2e7e8;}.cls-frnt10{fill:#6479a0;}.cls-frnt11{fill:#f2fafc;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-frnt1",
    cx: 142.5,
    cy: 142.5,
    r: 106
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt2",
    d: "M26.76,67.6a6.57,6.57,0,0,0-6.57,6.57l0,148.41a6.56,6.56,0,0,0,6.57,6.57l217.56.06a6.55,6.55,0,0,0,6.57-6.57l0-148.41a6.56,6.56,0,0,0-6.57-6.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt3",
    d: "M258.28,55.79H39.89a6.55,6.55,0,0,0-5.74,6.51l0,148.42a6.56,6.56,0,0,0,6.57,6.57l217.56.06a6.57,6.57,0,0,0,6.57-6.57l0-148.42a6.56,6.56,0,0,0-6.57-6.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt4",
    d: "M259.61,62.36l0,148.42a1.35,1.35,0,0,1-1.34,1.33l-217.56-.06a1.3,1.3,0,0,1-1.33-1.33l0-148.41a1.25,1.25,0,0,1,.32-.86,1.3,1.3,0,0,1,1-.47L258.28,61a1.33,1.33,0,0,1,1.06.52A1.32,1.32,0,0,1,259.61,62.36Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-frnt5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt6",
    d: "M216.15,180v-3.45a17.71,17.71,0,0,0,0-35.41v-3.46a21.16,21.16,0,0,1,0,42.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt6",
    d: "M216.15,168.74A9.9,9.9,0,0,1,207,155l3.19,1.35a6.28,6.28,0,0,0-.51,2.5,6.44,6.44,0,1,0,12.87,0H226A9.91,9.91,0,0,1,216.15,168.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt6",
    d: "M216.11,180a21.16,21.16,0,0,1-18.29-31.74l3,1.73a17.71,17.71,0,0,0,30.67,17.71l3,1.72A21.17,21.17,0,0,1,216.11,180Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt2",
    d: "M259.58,200.42v10.36a1.35,1.35,0,0,1-1.34,1.33l-217.56-.06a1.3,1.3,0,0,1-1.33-1.33v-6l.43-.1a35.31,35.31,0,0,0,13.33-6.39c.58-.42,1.14-.85,1.7-1.28.83-.64,1.65-1.29,2.45-1.94s1.6-1.28,2.4-1.9a39.81,39.81,0,0,1,10.85-6.4,35.85,35.85,0,0,1,12.57-2,36.08,36.08,0,0,1,12.57,2,40,40,0,0,1,10.84,6.41c.81.63,1.6,1.27,2.4,1.9s1.63,1.3,2.46,1.94c.55.44,1.12.86,1.7,1.28.17.14.34.26.53.39a37.82,37.82,0,0,0,3.82,2.46,31.91,31.91,0,0,0,7.49,3.17,38.53,38.53,0,0,0,10.6,1.37,39.49,39.49,0,0,0,9.11-1,33.83,33.83,0,0,0,11.45-5.08c.64-.42,1.27-.86,1.88-1.31a0,0,0,0,0,0,0c.56-.42,1.14-.84,1.69-1.27l2.46-1.94,2.42-1.91a39.7,39.7,0,0,1,10.84-6.4,39.62,39.62,0,0,1,25.13,0,40.21,40.21,0,0,1,10.85,6.4l2.41,1.91c.8.65,1.62,1.3,2.45,1.94.55.44,1.12.87,1.69,1.28a35.49,35.49,0,0,0,13.32,6.4,42.67,42.67,0,0,0,18.23,0A33.07,33.07,0,0,0,259.58,200.42Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-frnt1",
    x: 49.39,
    y: 73.6,
    width: 64.88,
    height: 81.79
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-frnt7",
    x: 130.53,
    y: 80.62,
    width: 110.22,
    height: 4.19
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-frnt7",
    x: 130.53,
    y: 96.51,
    width: 94.63,
    height: 4.19
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-frnt7",
    x: 130.52,
    y: 117.62,
    width: 35.31,
    height: 4.19
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-frnt7",
    x: 130.52,
    y: 147.72,
    width: 35.31,
    height: 4.19
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-frnt7",
    x: 198.27,
    y: 190.19,
    width: 40.45,
    height: 4.19
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-frnt7",
    x: 130.52,
    y: 127.76,
    width: 90.55,
    height: 4.19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt3",
    d: "M102.68,140.26c-2.31-2.69-20.59-8.61-20.59-8.61s-17.9,6.55-20.59,8.61-3.7,15.14-3.7,15.14h48.06S105,143,102.68,140.26Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt8",
    d: "M90.41,135.44l-8.32,3.17-8.32-3.17v-4.25a28.58,28.58,0,0,1,8.53-1.33,24.28,24.28,0,0,1,8.11,1.33Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-frnt9",
    points: "89.16 131.54 82.09 134.72 75.02 131.54 75.02 125.96 89.16 125.96 89.16 131.54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt10",
    d: "M96.35,115v-7.68c0-10.75-4.31-18-14-18s-14.06,7.22-14.06,18V115a41.72,41.72,0,0,0,4.11-4c.88-1-2.14-6.51-1.22-8.82a12.56,12.56,0,0,1,4-4.81s1.19,1.37,6.42,1.85,7.24-2.47,7.24-2.47.45,12.28,1.65,13.89A12.14,12.14,0,0,0,96.35,115Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt6",
    d: "M97.05,111.78c0,2.39-1.69,5.68-2.84,5.68s-2.06-1.94-2.06-4.33a5.15,5.15,0,0,1,2.06-4.33C95.32,107.93,97.05,108.8,97.05,111.78Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt6",
    d: "M67.44,111.78c0,2.39,1.69,5.68,2.84,5.68s2.07-1.94,2.07-4.33a5.13,5.13,0,0,0-2.07-4.33C69.17,107.93,67.44,108.8,67.44,111.78Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt11",
    d: "M82.3,92.83c-8,0-11.59,5.63-11.59,14v10.51a24.63,24.63,0,0,0,1.15,6.74c1.91,3.92,7.54,8.27,10.21,8.27s9-4.3,10.51-8a31.85,31.85,0,0,0,1.3-7.65v-9.84C93.88,98.46,90.33,92.83,82.3,92.83Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-frnt10",
    d: "M93.88,112.84l.72-4.36c.51-9.91-4.27-17.23-12.3-17.23s-12.41,8.38-12.1,17.23l.51,4.36s0-3.27,1.64-5c.73-.78,0-3.2.74-5a10,10,0,0,1,3.28-3.75s1,1.07,5.29,1.44,6-1.92,6-1.92,2.64.2,4.09,3.59c.94,2.18.22,3.19.15,4.57S93.88,112.84,93.88,112.84Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdFront);
export default __webpack_public_path__ + "static/media/id-front.96d73daf55829a2b4a577cfe91c15e81.svg";
export { ForwardRef as ReactComponent };